import * as yup from 'yup';

export const UpdateCourseFormValidation = yup.object().shape({
    description: yup.string().required('Descrição do curso é obrigatório'),
    id: yup.string().required('id do curso é obrigatório'),
    idDepartament: yup.string().required('Departamento é obrigatória'),
    duration: yup.number().typeError('Duração deve ser um número')
        .required('Duração do curso é obrigatória')
        // .positive('A duração deve ser maior que zero')
        ,
    name: yup.string().required('Nome do curso é obrigatório'),
    code: yup.string().required(" Código do curso é obrigatório"),
    status: yup.bool().required('estado do curso é obrigatório'),
    idUniversity: yup.string().required("Instituição de Ensino Superior é obrigatória"),
    idFaculty: yup.string().required("Unidade orgânica é obrigatória"),
    //idPlan: yup.string().required("Plano de curso é obrigatória"),
     idKnowledgeSubDomain: yup.string().required('Subdominio de conhecimento é obrigatório '),
   idKnowledgeDomain: yup.string().required('Dominio de conhecimento é obrigatório'),



});